enum ContactPointType {
    Work,
    Personal,
    Other
}

export { ContactPointType };
